import axios from "axios";
import Cookies from "js-cookie";
import config from "../../../config";

const baseUrl = config.baseUrl;
const beseEndpoint = "/api/deleteVisitaTecnica";

const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const deleteVisitaTecnica = async (id) => {
  try {
    const response = await axios.put(`${baseUrl}${beseEndpoint}/${id}`, {
      headers: {
        "Content-Type": "application/json", // Encabezado JSON para enviar datos correctamente
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar  la visita Tecnica:", error);
    throw error;
  }
};
export default deleteVisitaTecnica;
